module.exports = __webpack_public_path__ + "img/20190820133017126.4a723535.png";